/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next"
import { FOOD_MUI_ICONS, FoodMuiIcon, MenuIconType } from "../../../common/context/SharedFormTypes"
import { IconPicker } from "./IconPicker"
import {
    Restaurant, LocalBar, LocalCafe, LocalPizza, LunchDining,
    BakeryDining, RamenDining, Icecream, Cake, SetMeal,
    Tapas, SoupKitchen, KebabDining, LocalDining,
    WineBar, EmojiFoodBeverage, DinnerDining, BrunchDining,
    EggAlt, RiceBowl
} from "@mui/icons-material"

export const FOOD_EMOJIS = [
    '🍕', '🍔', '🍣', '🥗', '🍰', '🍷', '🥂', '🍾',
    '🧁', '🍩', '🍪', '🧀', '🥩', '🍗', '🥘', '🫕',
    '🍝', '🥐', '☕', '🍵', '🧃', '🍹', '🫒', '🥖',
    '🍲', '🧆', '🥮', '🍡', '🎂', '🍦', '🥤', '🫖'
]

export const FOOD_MUI_ICON_MAP: Record<FoodMuiIcon, React.ReactElement> = {
    Restaurant: <Restaurant />,
    LocalBar: <LocalBar />,
    LocalCafe: <LocalCafe />,
    LocalPizza: <LocalPizza />,
    LunchDining: <LunchDining />,
    BakeryDining: <BakeryDining />,
    RamenDining: <RamenDining />,
    Icecream: <Icecream />,
    Cake: <Cake />,
    SetMeal: <SetMeal />,
    Tapas: <Tapas />,
    SoupKitchen: <SoupKitchen />,
    KebabDining: <KebabDining />,
    LocalDining: <LocalDining />,
    WineBar: <WineBar />,
    EmojiFoodBeverage: <EmojiFoodBeverage />,
    DinnerDining: <DinnerDining />,
    BrunchDining: <BrunchDining />,
    EggAlt: <EggAlt />,
    RiceBowl: <RiceBowl />
}

export const getMuiIconElement = (iconName: string): React.ReactElement | null => {
    return FOOD_MUI_ICON_MAP[iconName as FoodMuiIcon] ?? null
}

interface MenuIconPickerProps {
    iconType: MenuIconType
    iconValue: string
    primaryColor: string
    onSelect: (type: MenuIconType, value: string) => void
}

export const MenuIconPicker = ({ iconType, iconValue, primaryColor, onSelect }: MenuIconPickerProps) => {
    const { t } = useTranslation()

    return (
        <IconPicker
            iconType={iconType}
            iconValue={iconValue}
            primaryColor={primaryColor}
            emojis={FOOD_EMOJIS}
            muiIcons={FOOD_MUI_ICONS}
            muiIconMap={FOOD_MUI_ICON_MAP}
            label={t('questionnaire.menu.sectionDialog.icon')}
            emojiTabLabel={t('questionnaire.menu.sectionDialog.emojiTab')}
            muiTabLabel={t('questionnaire.menu.sectionDialog.muiTab')}
            onSelect={onSelect}
        />
    )
}
